<template>
  <div class="flex flex-column align-items-center justify-content-center pt-4  mb-5">
    <h3 v-for="(item, index) of steps" :key="index" class="Paragraph-Regular mb-2  align-self-start">{{ item.step }}</h3>

    <div class="flex flex-wrap justify-content-center gap-3">

    </div>

    <Button label="Get Started" class="teal-button mt-6" @click="nextStep" />
    <label for="username" class="Caption pt-3">It only take 10-15 minutes. We’ll save as you go</label>
  </div>
</template>

<script setup>
import { defineEmits } from "vue";
import Button from 'primevue/button';

const steps = [
  { step: "1. Add your personal and teaching details" },
  { step: "2. Prove your educational qualifications" },
  { step: "3. Face & ID verification process" }
]

const emit = defineEmits(["get-started",]);
const nextStep = () => {
  emit("get-started");
};
</script>

<style scoped>
.pill-option {
  padding: 8px 16px;
  border: 2px solid var(--gray-300);
  border-radius: 50px;
  background: white;
  transition: all 0.3s ease;
  min-width: 200px;
  text-align: center;
  user-select: none;
}

.pill-option:hover {
  border-color: var(--teal-200);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(99, 102, 241, 0.2);
}

.pill-option-selected {
  border-color: var(--teal-200);
  background: var(--teal-200);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.3);
}

.pill-option-selected .Paragraph-Regular,
.pill-option-selected .pi {
  color: white;
}

.pill-option:not(.pill-option-selected) .pi {
  color: var(--teal-500);
}

@media (max-width: 768px) {
  .pill-option {
    min-width: 150px;
    padding: 0.6rem 1.2rem;
  }
}
</style>
